<template>
  <OButton v-bind="$attrs" :color-scheme="color" class="btn--modal text-sm min-w-24" size="sm" v-on="$listeners">
    <slot />
  </OButton>
</template>

<script>
// TODO: Burası setup'a çevrilebilir
import { OButton } from '~/modules/common/components/ui';
export default {
  components: { OButton },
  inheritAttrs: false,
  props: {
    colorScheme: {
      default: 'default',
      type: String,
    },
  },
  computed: {
    color() {
      const colors = {
        default: 'gray',
        primary: 'blue',
        success: 'green',
        danger: 'red',
      };
      return colors[this.colorScheme];
    },
  },
};
</script>
